<div class="page-container">
    <div *ngIf="loading" class="loading-container">
        <div class="loading">
            <div class="spinner-border" role="status">
                <span class="sr-only"></span>
            </div>
        </div>
    </div>
    <div class="content-container" *ngIf="!loading">
        <!-- Conditional main headlines and description -->
        <ng-container *ngIf="isPPI">
            <h2 class="headline-highlight">Manage Payment Methods</h2>
            <p>Your default payment will be charged for manual invoice payments.</p>
        </ng-container>
        <ng-container *ngIf="!isPPI">
            <h2 class="headline-highlight">Manage Payment Methods</h2>
            <p>Manage payment methods for automatic payments and redemption</p>
        </ng-container>

        <div class="box-border">
            <!-- Conditional sub-headline -->
            <ng-container *ngIf="isPPI">
                <h4 class="pmt-headline">My Credit Card(s)</h4>
                <!-- Display PPI Credit Cards -->
                <div *ngIf="cctokens.length === 0" class="sections">
                    <label class="noachtookens">No credit card on file</label><br>
                </div>
                <div *ngIf="cctokens.length > 0">
                    <div *ngFor="let cctoken of cctokens" class="tokendiv">
                        <input type="radio" class="form-check-input" name="defaultCard" [(ngModel)]="selectedtoken" value="{{cctoken.userCreditCardId}}" (click)="enableBtn()" />
                        <span class="bank-icons"><img class="pay-icon" [src]="cctoken.cardImg"></span>
                        <div class="info">
                            <span class="card-info">{{cctoken.creditCardType}} </span> 

                             <span class="card-info"> **** {{cctoken.last4}} &middot; {{cctoken.ccExpiration}}</span>
                            <span>{{cctoken.ccHolderName}}</span>
                            <div *ngIf="cctoken.isDefault" class="default-div">
                               
                            </div>
                        </div>
                         <!-- Edit Link for PPI -->
                        <div class="edit-link">
                            <a (click)="editPaymentMethod(cctoken)">Edit</a>
                        </div>
                        <!-- <div *ngIf="cctoken.isDefault?.toLowerCase()=='true'" class="default-div">
                            <label class="default">Default</label>
                        </div> -->
                        <div class="default-div">
                                <label *ngIf="cctoken.isDefault" class="default">Default</label>
                        </div>

                        <div class="delete">
                            <!-- You'll need a different API/logic for deleting PPI cards -->
                            <img (click)="deleteToken(cctoken.userCreditCardId)" class="delete-icon" src="../../../../assets/icons/delete.svg">
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="!isPPI">
                <h4 class="pmt-headline">Payment Methods</h4>
                <div *ngIf="isDefaultTokenAvailable"><p>Select One</p></div>
                <div *ngIf="!isDefaultTokenAvailable" class="no-default"><p>Set Default Payment Method *</p></div>
                
                <p class="pmt-method-type">ACH</p>
                <div *ngIf="ectokens==undefined || ectokens==''" class="sections">
                    <label class="noachtookens">No ACH on file</label>
                    <div class="chargestxt" *ngIf="!isBilliant">
                        <label class="chargeslbl">Earn </label>
                        <label class="percentage">0.75%</label>
                        <label class="chargeslbl"> back in rewards each time you pay with ACH</label>
                    </div>
                </div>
                <div *ngIf="ectokens!=undefined && ectokens!=''  ">
                    <div *ngFor="let ectoken of ectokens" class="tokendiv">
                        <input type="radio" class="form-check-input" [(ngModel)]="selectedtoken" (click)="enableBtn()" value="{{ectoken.token}}" />
                        <span class="bank-icons"><img class="pay-icon ach-icon" src="{{ectoken.cardImg}}"></span>
                        <div class="info info-ach">
                            <span>{{ectoken.ccholderName}}</span>
                            <span>**** {{ectoken.last4Digits}}</span>
                            <span *ngIf="!isBilliant">
                                <label class="chargeslbl">Earn</label>
                                <label class="percentage">0.75%</label>
                                <label class="chargeslbl">back in rewards each time you pay with ACH</label>
                            </span>
                        </div>
                        <div *ngIf="ectoken.isDefaultPaymentMethod.toLowerCase()=='true'" class="default-div">
                            <label class="default">Default</label>
                        </div>
                        <div class="delete">
                            <img (click)="deleteToken(ectoken.token)" class="delete-icon" src="../../../../assets/icons/delete.svg">
                        </div>
                    </div>
                </div>
                <hr>
                
                <p class="pmt-method-type">Credit Card</p>
                <div *ngIf="cctokens==undefined || cctokens==''" class="sections">
                    <label class="noachtookens">No credit card on file</label><br>
                </div>
                <div *ngIf="cctokens!=undefined && cctokens!=''">
                    <div *ngFor="let cctoken of cctokens" class="tokendiv">
                        <input type="radio" class="form-check-input" [(ngModel)]="selectedtoken" value="{{cctoken.token}}" (click)="enableBtn()" />
                        <span class="bank-icons"><img class="pay-icon" src="{{cctoken.cardImg}}"></span>
                        <div class="info">
                            <span>{{cctoken.cardType}}</span>
                            <span>**** {{cctoken.last4Digits}} &middot; {{ formatExpirationDate(cctoken.ccexpiration) }}</span>
                        </div>
                        <div *ngIf="cctoken.isDefaultPaymentMethod.toLowerCase()=='true'" class="default-div">
                            <label class="default">Default</label>
                        </div>
                        <div class="delete">
                            <img (click)="deleteToken(cctoken.token)" class="delete-icon" src="../../../../assets/icons/delete.svg">
                        </div>
                    </div>
                </div>
            </ng-container>
            
            <!-- Conditional Add New Payment Method link -->
            <div class="add-payment" (click)="addPaymentMethod()">
                <img src="../../../../assets/icons/add.svg">
                <a *ngIf="!isPPI">Add New Payment Method</a>
                <a *ngIf="isPPI">Add New Payment Card</a>
            </div>
        </div>

        <div class="btn">
            <button (click)="updateDefaultPayment()" *ngIf="!disablebtn && !InitialLoad" class="dw-primary-button">
                <span class="mdc-button__label">
                    <span class="button-label">
                        <span>Update My Default Card</span>
                        <mat-icon class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color">chevron_right</mat-icon>
                    </span>
                </span>
            </button>
            <button (click)="updateDefaultPayment()" *ngIf="disablebtn && !InitialLoad" disabled class="dw-primary-button">
                <span class="mdc-button__label">
                    <span class="button-label">
                        <span>Update My Default Card</span>
                        &nbsp;&nbsp;<span class="spinner-border"></span>
                    </span>
                </span>
            </button>
            <button (click)="updateDefaultPayment()" *ngIf="InitialLoad" disabled class="dw-primary-button">
                <span class="mdc-button__label">
                    <span class="button-label">
                        <span>Update My Default Card</span>
                        <mat-icon class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color">chevron_right</mat-icon>
                    </span>
                </span>
            </button>
        </div>

        <div class="error" *ngIf="systemError">
            Something went wrong! Please try again later.
        </div>
    </div>
</div>
